module.exports = __webpack_public_path__ + "static/media/9.21d4215d.png";